import angular from 'angular';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('PlannedregistrationScheduleDialogCtrl', [
    'resourceFactorySvc',
    'flySvc',
    'dialogsSvc',
    '$element',
    'close',
    'plannedRegistration',
    plannedregistrationScheduleDialogCtrl,
  ]);

function plannedregistrationScheduleDialogCtrl(
  resourceFactorySvc,
  flySvc,
  dialogsSvc,
  $element,
  close,
  plannedRegistration,
) {
  var vm = this;
  vm.lines = [];
  vm.showHistory = false;
  vm.historyEnabled = false;
  var today = moment
    .utc()
    .startOf('day')
    .toDate();
  vm.dateOptions = {
    minDate: today,
  };

  var resource = resourceFactorySvc.get('plannedRegistration');

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };

  resource.scheduleLines(
    {
      id: plannedRegistration.id,
    },
    function(data) {
      vm.lines = data;

      vm.historyEnabled = vm.lines.some(function(line) {
        return line.processed === true;
      });
    },
    showError,
  );

  vm.cancel = function() {
    close(null, 500);
  };

  vm.updateLine = function(line, field, data) {
    //Validation error
    if (typeof data === 'undefined') return '';
    if (field === 'date' && !data) return '';
    if (angular.equals(line[field], data)) return false;
    var model = angular.copy(line);
    model[field] = data;
    return resource.updateSchedule(model).$promise.then(function(response) {
      if (response) {
        angular.extend(line, response);
        flySvc.success('msgConfirmChange');
      }
      return false;
    }, showError);
  };

  vm.deleteLine = function(id) {
    dialogsSvc
      .showYesNo('msgConfirmDeleteTitle', 'msgDeletePlannedRegistrationLine')
      .then(function() {
        resource
          .deleteSchedule({
            id: id,
          })
          .$promise.then(function(response) {
            if (response) {
              flySvc.success('msgPlannedRegistrationLineDeleted');

              if (vm.lines) {
                for (var t = 0; t < vm.lines.length; t++) {
                  if (vm.lines[t].id === id) {
                    vm.lines.splice(t, 1);
                    break;
                  }
                }
              }
            }
            return false;
          }, showError);
      });
  };
}
